<div class="login-page">
  <div class="login-form">
    <app-application-environment-message class="login__application-environment-message">
    </app-application-environment-message>

    <h5 class="login-form__header">
      <div class="login-form__header-logo">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
          <g clip-path="url(#clip0_815_128)">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M22.2507 0C4.91619 1.41042 -2.2415 15.7751 0.609525 24.8062C2.28081 22.23 5.39189 19.425 11.7536 18.3863C11.3857 10.7783 14.1384 5.47014 22.2507 0Z"
              fill="#1D5080"
            />
            <path
              d="M13.3637 19.4789C8.98413 20.1968 5.93648 21.3848 4.02734 23.186C4.0852 25.5935 4.77423 27.9434 6.02528 29.9998C7.50629 26.3817 12.3679 23.8213 19.7571 23.8022C17.959 15.1301 21.9771 7.18535 28.2246 1.85181C25.1324 2.30981 22.103 3.12199 19.1958 4.27239C14.4388 8.85625 12.666 14.7648 13.3637 19.4789Z"
              fill="#1D5080"
            />
          </g>
        </svg>
      </div>

      <span class="login-form__header-title">PitchBook LCD Delivery System</span>
    </h5>

    <div class="login-form__inputs-container">
      <div class="login-form__input-group">
        <div class="login-form__input-label">Username</div>

        <lib-text-input class="login-form__input" [(model)]="username"> </lib-text-input>
      </div>

      <div class="login-form__input-group">
        <div class="login-form__input-label">Password</div>

        <lib-text-input class="login-form__input" [(model)]="password" [attributeInputType]="inputType.Password">
        </lib-text-input>
      </div>
    </div>

    <div *ngIf="!userAuthorized && loginError" class="login-form__warning-message">
      <span class="login-form__warning-message-text">
        Sorry, your username and/or password are incorrect - please try again.
      </span>
    </div>

    <div class="login-form__footer">
      <div class="login-form__reset-link-container">
        <a href="javascript:void(0)" class="login-form__reset-link" (click)="onResetClick()"> Forgot your password? </a>
      </div>

      <lib-button class="login-form__submit-button" [busy]="loginInProgress" (click)="onSubmit()"> Log in </lib-button>
    </div>
  </div>
</div>
